import { PayloadAction, createSlice } from '@reduxjs/toolkit';

export const permissionInitState: MenuConfigDto = {
  menuItems: [],
  userContext: {} as UserContext,
  globalActions: [],
  lastUpdated: '',
  sections: [],
};

const slice = createSlice({
  name: 'permissions',
  initialState: permissionInitState,
  reducers: {
    setMenusUserAction(state, { payload }: PayloadAction<MenuConfigDto>) {
      state.menuItems = payload.menuItems || [];
    },
    setUserContextAction(state, { payload }: PayloadAction<MenuConfigDto>) {
      state.userContext = payload.userContext;
    },
    setGlobalActionsAction(state, { payload }: PayloadAction<MenuConfigDto>) {
      state.globalActions = payload.globalActions;
    },
    setLastUpdatedAction(state, { payload }: PayloadAction<MenuConfigDto>) {
      state.lastUpdated = payload.lastUpdated;
    },
    setMenusSettingAction(state, { payload }: PayloadAction<MenuConfigDto>) {
      state.sections = payload.sections || [];
    },
  },
});

export const {
  setMenusUserAction,
  setUserContextAction,
  setGlobalActionsAction,
  setLastUpdatedAction,
  setMenusSettingAction,
} = slice.actions;
export default slice.reducer;
